<template>
    <div style="display: flex">
      <div :class="switchShow" style="flex: 1">
        <el-row>
          <el-col :span="17">
            <!-- 面包屑导航区域-->
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
              <el-breadcrumb-item>Factory</el-breadcrumb-item>
              <el-breadcrumb-item>Sub Item</el-breadcrumb-item>
            </el-breadcrumb>
          </el-col>
        </el-row>
        <el-card>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="Sub Item:">
              <el-input v-model="formInline.subitemNo" placeholder="Sub Item" clearable></el-input>
            </el-form-item>
            <el-form-item label="Description:">
              <el-input v-model="formInline.description" placeholder="Description" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">Search</el-button>
            </el-form-item>
            <br>
            <el-form-item>
              <el-button type="primary" @click="customerDialogOpen('add', '')">Add</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="subItemList" border stripe style="width: 100%">
            <el-table-column
              prop="id"
              label="Id"         sortable
              width="150">
            </el-table-column>
            <el-table-column
              prop="subitemNo"
              label="Sub Item"         sortable
              width="150">
            </el-table-column>
            <el-table-column
              prop="description"
              label="Description"
              width="180">
            </el-table-column>
            <el-table-column
              prop="productionLineType"
              label="Type"
              width="150">
            </el-table-column>
            <el-table-column
              prop="picUrl"
              label="Picture"
              width="150">
              <template slot-scope="scope">
                <img :src="scope.row.picUrl" min-width="30" height="30" @click="showpreviewPic(scope.row.picUrl,scope.row.items)">
              </template>
            </el-table-column>

            <el-table-column label="Operation" width="350">
              <template slot-scope="index">
                <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
                <el-button type="info" plain size="mini" @click="getItems(index)">Items</el-button>
                <!--              <el-button type="info" plain size="mini" @click="getPermissions(index)">Followers</el-button>-->
                <el-button type="info" plain size="mini" @click="customerDialogOpen('edit', index)">Edit</el-button>
                <!--          <el-button type="info" plain size="mini" @click="del(props.row.code)">Delete</el-button>-->
              </template>
            </el-table-column>

          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
          <el-dialog title="Sub Item"
                     width="50%" :visible.sync="dialogFormVisible" >
            <el-form :model="subItem" label-width="200px" ref="userOpenform">
              <el-form-item required label="Subitem No:" prop="subItem.subitemNo">
                <el-input v-model="subItem.subitemNo" style="width: 300px"></el-input>
              </el-form-item>
<!--              <el-form-item required label="Id:" prop="subItem.id">-->
<!--                <el-input v-model="subItem.id" style="width: 300px"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item required label="Description:" prop="subItem.description">
                <el-input v-model="subItem.description" style="width: 300px"></el-input>
              </el-form-item>
<!--              <el-form-item required label="Type:" prop="subItem.productionLineType">-->
<!--                <el-input v-model="subItem.productionLineType" style="width: 300px"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item required label="Type:" prop="subItem.productionLineType">
                <el-radio-group v-model="subItem.productionLineType">
                  <el-radio label="Injection"></el-radio>
                  <el-radio label="Assembly"></el-radio>
                  <el-radio label="Furnace"></el-radio>
                </el-radio-group>
              </el-form-item>
<!--              <el-form-item required label="Picture:" prop="subItem.picUrl">-->
<!--                <el-input v-model="subItem.picUrl" style="width: 300px"></el-input>-->
<!--              </el-form-item> -->
              <el-form-item required label="Picture:">
                  <span style="color: red">*</span>
                  <br>
                  <el-upload
                    class="avatar-uploader"
                    ref="upload"
                    :limit="1"
                    :action="uploadImgUrl"
                    :before-upload="beforeAvatarUpload"
                    :on-success="handleAvatarSuccess"
                    :show-file-list ="true"
                    list-type="picture"
                    :multiple="false"
                    accept=".jpg, .png"
                  >
                    <img v-if="subItem.picUrl" :src="subItem.picUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__tip" slot="tip">Must be JPG/PNG and less than 2MB</div>
                  </el-upload>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">Cancel</el-button>
              <el-button type="primary" @click="customerDialogSave()">Save</el-button>
            </div>
          </el-dialog>

          <el-dialog title="Choose item"
                     width="50%" :visible.sync="dialogFormVisible2">
            <div label="Item Description:">
<!--              <span style="color: red">*</span>-->
<!--              <br>-->
              <el-select v-model="form.brand" placeholder="Please select brand" @change="changeBrand">
                <!--                <el-option label="区域一" value="shanghai"></el-option>-->
                <el-option :key="item.key" v-for="item in brandList" :value="item"></el-option>
              </el-select>
              <!--              <el-input v-model="form.item" placeholder="Keyword search"></el-input>-->

              <el-select
                style="width: 100%"
                v-if="form.brand"
                v-model="value"
                multiple
                filterable
                remote
                reserve-keyword
                placeholder="Keyword search"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <br>
            <div style="text-align: right">
              <el-button @click="dialogFormVisible2 = false">Cancel</el-button>
              <el-button type="primary" @click="subItemSave()">Save</el-button>
            </div>
          </el-dialog>
        </el-card>
      </div>
      <div v-if = "switchShow === 'show'" style="flex: 1">
<!--        <div :class="switchShow" style="flex: 1">-->
          <el-row>
            <el-col :span="17">
              <!-- 面包屑导航区域-->
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Sub Item No: {{switchSubItemNo}} </el-breadcrumb-item>
              </el-breadcrumb>
            </el-col>
          </el-row>
          <el-card>
            <div style="display: flex">
              <div style="flex: 1;text-align: left">
                <div style="display: flex">
                  <div style="flex: 1;text-align: left">
                    <el-button type="primary" @click="addItem()">Add Item</el-button>
                  </div>
                  <div style="flex: 1;text-align: right">
                    <el-button size="mini"  @click="closeSwich()">Close</el-button>
                  </div>
                </div>
              </div>
            </div>
            <el-divider></el-divider>
            <div  v-loading="loading">
              <div style="display: flex;;height: 2rem;margin-top: 1rem" v-for="item in this.subitemItem"
                   :key="item"
                   :label="item"
                   :value="item">
                <p>
                <span style="flex: 3">
<!--                  <i class="el-icon-takeaway-box"></i>-->
                  {{item.item}}|</span>
                <span>{{item.description}}|</span>
                <span>{{item.supplier}}|</span>
                <span>{{item.brand}}</span>
                </p>
                <p style="flex: 1;text-align: right">
                  <el-button size="mini" type="danger" @click="subitemItemDelete(item)" >Delete</el-button>
                </p>
              </div>
            </div>
          </el-card>
<!--        </div>-->
      </div>
      </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SubItem',
  data () {
    return {
      subitemItem: [],
      loading: false,
      newItems: [],
      options: [],
      value: [],
      brandList: [],
      form: {
        brand: ''
      },
      switchSubItemNo: '',
      uploadImgUrl: axios.defaults.baseURL + '/file/upload/img/',
      items: '',
      lookdialogVisible: false,
      previewpic: '',
      total: 0,
      subItemList: [],
      switchShow: 'unshow',
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialog: '',
      subItem: {
        picUrl: ''
      },
      formInline: {
        subitemNo: '',
        // description: '',
        // productionLineType: '',
        // picUrl: '',
        page: 1,
        size: 100,
        rows: 100
      },
      resetForm: {
        subitemNo: '',
        // description: '',
        // productionLineType: '',
        // picUrl: '',
        page: 1,
        size: 100,
        rows: 100
      }
    }
  },
  created () {
    this.getList()
    this.getBrandList()
  },
  methods: {
    async handleSizeChange (val) {
      this.formInline.size = val
      const { data: res } = await this.$http.get('/subitem/getSubitemList', { params: this.formInline })
      this.subItemList = res.records
      this.total = res.total
    },
    async handleCurrentChange (val) {
      this.formInline.page = val
      const { data: res } = await this.$http.get('/subitem/getSubitemList', { params: this.formInline })
      this.subItemList = res.records
      this.total = res.total
    },
    async subitemItemDelete (x) {
      this.loading = true
      await this.$http.get('/subitem/subitemItemDelete?id=' + x.id)
        .then((res) => {
          this.$http.get('/subitem/getSubitemItemList', {
            params: {
              subitemNo: this.switchSubItemNo
            }
          }
          )
            .then((ress) => {
              this.subitemItem = ress.data
              this.loading = false
            })
        })
    },
    async subItemSave () {
      // console.log(this.value)
      const list = []
      for (let i = 0; i < this.value.length; i++) {
        // list.push(this.value[i].split('|')[0])
        list.push(this.value[i])
      }
      await this.$http.post('/subitem/saveOrUpdateSubitemItemList?subitem=' + this.switchSubItemNo, list)
        .then((res) => {
          if (res.data === 200) {
            this.$message({
              message: 'Added or updated successfully',
              type: 'success'
            })
            this.dialogFormVisible2 = false
            this.switchShow = 'unshow'
          }
        })
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.newItems.filter(item => {
            return item.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    async changeBrand () {
      await this.$http.get('/subitem/getItemListByBrand?brand=' + this.form.brand)
        .then((ress) => {
          this.options = ress.data
          this.newItems = ress.data
        })
    },
    async getBrandList () {
      await this.$http.get('/machine/getBrandList')
        .then((ress) => {
          this.brandList = ress.data
        })
    },
    addItem () {
      this.dialogFormVisible2 = true
      this.value = []
    },
    closeSwich () {
      this.switchShow = 'unshow'
      // this.getSupplierList()
    },
    async getItems (x) {
      this.subitemItem = []
      this.switchShow = 'show'
      document.documentElement.scrollTop = 0
      this.switchSubItemNo = x.row.subitemNo
      const { data: res } = await this.$http.get('/subitem/getSubitemItemList',
        {
          params: {
            subitemNo: this.switchSubItemNo
          }
        }
      )
      this.subitemItem = res
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!(file.type === 'image/jpeg' || file.type === 'image/png')) {
        this.$message.error('The format must be JPG/PNG!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('Must be less than 2MB!')
        return false
      }
    },
    handleAvatarSuccess (res, file) {
      // this.$refs.upload.clearFiles()
      // this.form.picUrl = URL.createObjectURL(file.raw)
      this.subItem.picUrl = res
    },
    async customerDialogSave () {
      if (!this.subItem.subitemNo) {
        this.$message({
          message: 'Please enter Subitem No',
          type: 'warning'
        })
        return
      }
      if (!this.subItem.description) {
        this.$message({
          message: 'Please enter description',
          type: 'warning'
        })
        return
      }
      if (!this.subItem.productionLineType) {
        this.$message({
          message: 'Please enter Type',
          type: 'warning'
        })
        return
      }
      if (!this.subItem.picUrl) {
        this.$message({
          message: 'Please upload picture',
          type: 'warning'
        })
        return
      }
      await this.$http.post('/subitem/saveOrUpdateSubitemList', this.subItem)
        .then((res) => {
          console.log(res)
          if (res.data === 200) {
            this.$notify({
              title: 'Success',
              type: 'success'
            })
          }
          if (res.data === 501) {
            this.$notify({
              title: 'This Subitem No is already exists',
              type: 'warning'
            })
          }
          this.dialogFormVisible = false
          this.getList()
        })
    },
    showpreviewPic (url, items) {
      this.items = items
      this.previewpic = url
      this.lookdialogVisible = true
    },
    async getList () {
      const { data: res } = await this.$http.get('/subitem/getSubitemList', { params: this.formInline })
      this.subItemList = res.records
      this.total = res.total
    },
    onSubmit () {
      console.log('submit!')
      this.getList()
    },
    customerDialogOpen (x, i) {
      if (x === 'add') {
        this.dialogFormVisible = true
        this.dialog = 'add'
        this.subItem = {}
      } else {
        this.dialogFormVisible = true
        this.dialog = 'edit'
        this.subItem = i.row
      }
    }
  }
}
</script>

<style scoped>
  .show {
    width: 50%;
  }
  .unshow {
    width: 100%;
  }
</style>
